import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import SiteAccessPolicyTable from "../../components/charging/SiteAccessPolicyComponent/SiteAccessPolicyTable";
import { Box, Container, Paper, Typography, CircularProgress, Tabs, Tab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";
import { useApiService } from "../../services/ApiService/ApiService";

function SiteAccessPolicyListPage(props: any) {
  const navigate = useNavigate();
  const { userInfo } = useContext(UserContext);
  const { fetchWithAuth } = useApiService();
  const [surveys, setSurveys] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  const fetchSurveys = async () => {
    try {
      const response = await fetchWithAuth('/site-access-policy/list', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          uuid: userInfo.uuid,
          businessUuid: userInfo.businessUuid
        }),
      });

      if (!response.ok) {
        setIsError(true);
        return;
      }

      const res_json = await response.json();
      setSurveys(res_json.surveys.map((e: any) => ({ 
        ...e, 
        id: e.uuid, 
        name: e.name, 
        scope: e.scope 
      })));
    } catch (error) {
      console.error('Error fetching surveys:', error);
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSurveys();
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleAddNew = () => {
    navigate("/share/business/site-access-policies/edit");
  };
  
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <Paper elevation={0} sx={{ p: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <Typography variant="h5" component="h1" fontWeight="500">
              Site Access Policies
            </Typography>

          </Box>

          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange}
              aria-label="site access policy tabs"
            >
              <Tab label="All" />
            </Tabs>
          </Box>

          <SiteAccessPolicyTable surveys={surveys} />
        </Paper>
      </Box>
    </Container>
  );
}

export default SiteAccessPolicyListPage;
